import { IDefaultTheme } from "design-system/src/Themes/defaultTheme";

export enum EStoreOpenCode {
  FETCHING = -1,
  OPEN = 1,
  INTERNATIONAL = 2,
  EXCEPTIONAL_CLOSURE = 3,
  OPEN_SOON = 4,
  CLOSED_SOON = 5,
  CLOSED = 6,
}
export const StoreOpenCodeColors: Record<
  EStoreOpenCode,
  keyof IDefaultTheme["color"]
> = {
  [EStoreOpenCode.FETCHING]: "greyText",
  [EStoreOpenCode.OPEN]: "success",
  [EStoreOpenCode.OPEN_SOON]: "warning",
  [EStoreOpenCode.CLOSED]: "error",
  [EStoreOpenCode.CLOSED_SOON]: "warning",
  [EStoreOpenCode.EXCEPTIONAL_CLOSURE]: "error",
  [EStoreOpenCode.INTERNATIONAL]: "success",
};
